import { Component, ViewChild, Input, Output, EventEmitter, ElementRef, Renderer, ViewEncapsulation } from '@angular/core';
import { NgUploaderOptions } from 'ngx-uploader';

@Component({
    selector: 'ba-picture-uploader',
    styleUrls: ['./baPictureUploader.scss'],
    templateUrl: './baPictureUploader.html',
    encapsulation: ViewEncapsulation.None
})
export class BaPictureUploader {
    private errorMsg:string;

    @Input() defaultPicture:string = '';
    @Input() picture:string = '';
    @Input() linkTittle:string = '';

    @Input() uploaderOptions:NgUploaderOptions = { 
        url: '',
        customHeaders:'',
        fieldName: ''
    };
    @Input() canDelete:boolean = true;

    @Output() onUpload = new EventEmitter<any>();
    @Output() onUploadCompleted = new EventEmitter<any>();
    @Output() onRemove = new EventEmitter<any>();

    @ViewChild('fileUpload') public _fileUpload:ElementRef;

    public uploadInProgress:boolean;

    constructor(
        private renderer: Renderer
    ) { }

    beforeUpload(uploadingFile): void {
        let files = this._fileUpload.nativeElement.files;

        if (files.length) {
            const file = files[0];
            this._changePicture(file);

            if (!this._canUploadOnServer()) {
                uploadingFile.setAbort();
            } else {
                this.uploadInProgress = true;
            }
        }
    }

    bringFileSelector():boolean {
        this.renderer.invokeElementMethod(this._fileUpload.nativeElement, 'click');
        return false;
    }

    removePicture(bannerHorizontalPosition, bannerVerticalPosition):boolean {
        this.picture = '';
        this.onRemove.emit();
        return false;
    }

    _changePicture(file:File):void {
        const reader = new FileReader();
        reader.addEventListener('load', (event:Event) => {
              this.picture = (<any> event.target).result;
        }, false);
        reader.readAsDataURL(file);
    }

    _onUpload(data):void {
        if (data['done'] || data['abort'] || data['error']) {
            let response = JSON.parse(data.response);
            if(response.status === 'ERROR'){
                this.picture = '';
                this.uploadInProgress = false;
                this.errorMsg = response.error_msg;
            } else {
                this.errorMsg = '';
                this._onUploadCompleted(data);
            }
        } else {
            this.onUpload.emit(data);
        }
    }

    _onUploadCompleted(data):void {
        this.uploadInProgress = false;
        this.onUploadCompleted.emit(data);
    }

    _canUploadOnServer():boolean {
        return !!this.uploaderOptions['url'];
    }
}



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/components/baPictureUploader/baPictureUploader.component.ts